import { CatalogItem } from '@/types/service-catalog';

/**
 * Quem pode mexer na identidade de um serviço do negócio (nome, descrição,
 * foto): mesma regra da API (`assertCanEdit`) — o dono manda em qualquer item;
 * o profissional manda no que ele próprio criou, enquanto for o único a fazer.
 * Depois que outro passa a fazer, o serviço é da equipe.
 */
export function canEditCatalogIdentity(
  item: Pick<CatalogItem, 'createdByProviderId' | 'professionals'>,
  { isOwner, providerId }: { isOwner: boolean; providerId: string | null },
): boolean {
  if (isOwner) return true;
  if (!providerId || item.createdByProviderId !== providerId) return false;
  return item.professionals.every((professional) => professional.providerId === providerId);
}
